import { Box, Button, ScaleFade, useDisclosure } from '@chakra-ui/react';

interface ScoreDetailsQuestionTranscriptProps {
  transcript: string;
}

function ScoreDetailsQuestionTranscript(props: ScoreDetailsQuestionTranscriptProps) {
  const { transcript } = props;
  const { getDisclosureProps, isOpen, onToggle } = useDisclosure();
  const transcriptDisclosureProps = getDisclosureProps();

  return (
    <>
      <Box mt="2">
        <Button size="sm" onClick={onToggle}>
          {transcriptDisclosureProps.hidden === true ? 'Show ' : 'Hide '}
          transcript
        </Button>

        <ScaleFade in={isOpen}>
          <Box {...transcriptDisclosureProps} mt="4" ml="3" pl="3" borderLeftWidth="4px" fontSize="sm">
            {transcript}
          </Box>
        </ScaleFade>
      </Box>
    </>
  );
}

export default ScoreDetailsQuestionTranscript;
